import { validateUrls } from "api/types"

export const urls = validateUrls({
  representativesList: () => `/v1/schools/representatives/`,
  accessibleSchool: () => `/v1/jobs/representatives/schools/`,
})
